import { BackgroundLayout } from "../layouts/BackgroundLayout";
import { RegistrationView } from "../components/auth/registration/RegistrationView";

const RegistrationPage = () => {
  return (
    <BackgroundLayout>
      <RegistrationView />
    </BackgroundLayout>
  );
};

export { RegistrationPage };
